import './styles/global.css';

import { useScrollReveal } from './hooks/useScrollReveal';

import Navbar     from './components/Navbar/Navbar';
import Footer     from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

import Hero      from './sections/Hero/Hero';
import Stats     from './sections/Stats/Stats';
import About     from './sections/About/About';
import WhatWeDo  from './sections/WhatWeDo/WhatWeDo';
import Solutions from './sections/Solutions/Solutions';
import WhyUs     from './sections/WhyUs/WhyUs';
import CTA       from './sections/CTA/CTA';

function App() {
  useScrollReveal(); // attach IntersectionObserver to all .reveal elements

  return (
    <div>
      <Navbar />
      <Hero />
      <Stats />
      <About />
      <WhatWeDo />
      <Solutions />
      <WhyUs />
      <CTA />
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default App;
